/**
 * Menu controller.
 *
 * This class controls the site menu and search functions.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Menu
 */
class Menu {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {


        // The mobile menu toggler icon.
        this.mobileOverlayToggler = document.getElementById( 'js-mobile-overlay-toggle' );

        // The mobile full screen overlay that contains the mobile menu.
        this.mobileOverlay = document.getElementById( 'js-mobile-overlay' );

        // The mobile nav element.
        this.mobileMenu = document.getElementById( 'js-mobile-overlay__nav' );

        // Get first and last focusable elements of the mobile menu..
        if ( this.mobileMenu ) {

            const focusableElements = this.mobileMenu.querySelectorAll( 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]' );
            if ( focusableElements.length ) {
                const focusableElementsArr = Array.prototype.slice.call( focusableElements );

                this.firstMobileMenuLink = focusableElementsArr[0];
                this.lastMobileMenuLink = focusableElementsArr[focusableElementsArr.length - 1];

            }
        }

        // Each menu wrapper.
        this.menuWrappers = $( '.js-main-menu-nav' );
    }

    /**
     * All events of the menus
     * @return {void}
     */
    events() {
        document.addEventListener( 'keydown', evt => this.keyDownHandler( evt ) );
    }


    /**
     * Handle keydown events.
     *
     * @param {object} evt The key push event.
     * @return {void}
     */
    keyDownHandler( evt ) {

        // Return early if no modal exists.
        if ( ! this.mobileOverlay ) {
            return;
        }

        // Return early if modal not open.
        if ( ! this.mobileOverlay.classList.contains( 'js-active' ) ) {
            return;
        }

        evt = evt || window.event;

        const KEY_TAB = 9;
        const KEY_ESC = 27;

        switch ( evt.keyCode ) {
            case KEY_TAB:

                // Return early if no mobileOverlayToggler found.
                if ( ! this.mobileOverlayToggler ) {
                    return;
                }

                // Focus on mobileOverlayToggler and return early if no other focusable elements found.
                if ( ! this.firstMobileMenuLink ) {
                    evt.preventDefault();
                    this.mobileOverlayToggler.focus();
                    break;
                }

                this.handleTabKeyEvent( evt );

                break;
            case KEY_ESC:
                this.toggleMobileOverlay();
                break;
            default:
                break;
        } // end switch
    }


    /**
     * Handle tab key pushes inside modal.
     *
     * @param {object} evt The key push event.
     * @return {void}
     */
    handleTabKeyEvent( evt ) {

        if ( ! this.firstMobileMenuLink || ! this.mobileOverlayToggler ) {
            return;
        }

        // If shift + tab pushed.
        if ( evt.shiftKey ) {

            // Focus on last element if focus was on the mobileOverlayToggler element.
            if ( document.activeElement === this.mobileOverlayToggler ) {
                evt.preventDefault();
                this.lastMobileMenuLink.focus();
                return;
            }
        } else {

            // Focus on mobileOverlayToggler element if focus was on the last element.
            if ( document.activeElement === this.lastMobileMenuLink ) {

                evt.preventDefault();
                this.mobileOverlayToggler.focus();
                return;
            }
        }
    }

    /**
     * Toggles the sub menus open and closed
     * @return {void}
     */
    toggleSubMenu( e ) {

        // The clicked element
        let clickedElement  = e.target;

        // The link might contain an icon with the class 'menu-toggle__icon'. Check if the icon was clicked.
        if ( clickedElement.classList.contains( 'menu-toggle__icon' ) ) {
            clickedElement = e.target.parentNode;
        }

        // Get the parent elmenent of the clicked element.
        const clickedParent = clickedElement.parentNode;

        // Toggle aria expanded
        const isExpanded =  clickedElement.getAttribute( 'aria-expanded' );

        if ( isExpanded == 'false' ) {
            clickedElement.setAttribute( 'aria-expanded', 'true' );
        } else {
            clickedElement.setAttribute( 'aria-expanded', 'false' );
        }

        // Get the submenu inside the parent.
        const subMenu = Theme.Common.$1( '.sub-menu', clickedParent );

        // Toggle the clicked element's and the parent's active state and its sub menu's active state.
        clickedElement.classList.toggle( 'js-active' );
        clickedParent.classList.toggle( 'js-active' );
        if ( subMenu ) {
            subMenu.classList.toggle( 'js-active' );

            // Toggle the clicked parent's sub menu's aria-hidden state.
            Theme.Common.toggleAriaHidden( subMenu );
        }
    }


    /**
     * Toggles the mobile menu overlay open and closed
     * @return {void}
     */
    toggleMobileOverlay() {

        // Return early if missing required elements.
        if ( ! this.mobileOverlayToggler ||  ! this.mobileOverlay ) {
            return;
        }

        // Toggle the overlay's and the mobileOverlayToggler's active states.
        this.mobileOverlay.classList.toggle( 'js-active' );
        this.mobileOverlayToggler.classList.toggle( 'js-active' );
        document.body.classList.toggle( 'mobile-overlay-is-active' );

        // Get the toggler's aria-expanded current state and set a new opposite state to it.
        // Also set the opened container's aria-hidden state to the new value's opposite.
        const ariaExpandedState = this.mobileOverlayToggler.getAttribute( 'aria-expanded' ) === 'false' ? true : false;
        this.mobileOverlayToggler.setAttribute( 'aria-expanded', ariaExpandedState );
        this.mobileOverlay.setAttribute( 'aria-hidden', ! ariaExpandedState );

        // Return early if mobileOverlayToggler closed.
        if ( ! this.mobileOverlay.classList.contains( 'js-active' ) ) {
            this.mobileOverlayToggler.focus();
            return;
        }

        // Set a small delay to the focusing to back of mobile menu's toggler
        // because of the CSS fade in
        if ( this.mobileOverlay ) {
            setTimeout( () => {
                this.mobileOverlayToggler.focus();
            }, 500 );
        }

    }

    /**
     * Toggles the langugage nav menu open and closed
     * @return {void}
     */
    toggleLangMenu( e ) {

        // The clicked element
        let clickedElement  = e.target;

        // The link might contain an icon with the class 'lang-nav__link__icon'. Check if the icon was clicked.
        if ( clickedElement.classList.contains( 'lang-nav__link__icon' ) ) {
            clickedElement = e.target.parentNode;
        }

        if ( clickedElement.classList.contains( 'hide-from-screenreaders' ) ) {
            clickedElement = e.target.parentNode;
        }

        // Get the parent element of the clicked element.
        const clickedParent = clickedElement.parentNode;

        // Get the submenu inside the parent.
        const subMenu = Theme.Common.$1( '.lang-nav__sub-menu', clickedParent );

        // Toggle the clicked element's and the parent's active state and its sub menu's active state.
        clickedElement.classList.toggle( 'js-active' );
        clickedParent.classList.toggle( 'js-active' );
        if ( subMenu ) {
            subMenu.classList.toggle( 'js-active' );

            // Toggle the clicked parent's sub menu's aria-hidden state.
            Theme.Common.toggleAriaHidden( subMenu );
        }
    }

    /**
     * Toggle current menu tree open on page load.
     *
     * @param {object} $menuWrappers jQuery object of menu wrapper elements.
     * @return {void}
     */
    static openCurrentMenu( $menuWrappers ) {

        // Run code only if there's a menu that has sub items.
        if ( $menuWrappers.length ) {

            $menuWrappers.each( function( index, menu ) {

                const $menu                 = $( menu );
                const $currentMenuItem      = $menu.find( '.current-menu-item' );

                if ( $currentMenuItem.length ) {

                    /** -----------------------------------------
                     *  Current menu item is parent level item.
                     *  The menu classes act differently for lvl1
                     *  active item.
                     *  ----------------------------------------- */

                    if ( $currentMenuItem.hasClass( 'menu-item--lvl-1' ) ) {

                        const $menuLvl1ToggleButton = $currentMenuItem.children( '.menu-toggle' );
                        const $menuSubmenuLvl2      = $currentMenuItem.children( '.sub-menu' );

                        // Change toggle button state to active.
                        if ( $menuLvl1ToggleButton.length ) {
                            $menuLvl1ToggleButton.addClass( 'js-active' );
                        }

                        // Show submenu from the first child level lvl2.
                        if ( $menuSubmenuLvl2.length ) {
                            $menuSubmenuLvl2.addClass( 'js-active' );
                        }

                    } else {

                        /** -------------------------------------
                         *  Current menu item is on the sub level
                         *  ------------------------------------- */

                        const $currentItemParentSubMenus = $currentMenuItem.parents( '.sub-menu' );
                        $currentItemParentSubMenus.addClass( 'js-active' );

                        // Iterate through current item parent sub menus.
                        $currentItemParentSubMenus.each( function( index, subMenu ) {
                            $( subMenu ).prev( '.menu-toggle' ).addClass( 'js-active' );
                        });

                        // Show current menu item child if has any.
                        if ( $currentMenuItem.hasClass( 'menu-item-has-children' ) ) {
                            $currentMenuItem.children( '.sub-menu' ).addClass( 'js-active' );
                            $currentMenuItem.children( '.menu-toggle' ).addClass( 'js-active' );
                        }
                    }
                }
            });
        }
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.constructor.openCurrentMenu( this.menuWrappers );
    }
}

// Export the class reference.
module.exports = Menu;



// WEBPACK FOOTER //
// ./assets/scripts/menu.js